/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import cookies from 'js-cookie';

export default {
  methods: {
    async downloadFile({
      target = '', courseId = false, name, assignmentId = false, lectureId = false, index = false, certificateId = false, courseZip = false, assignmentZip = false, url = false, textLesson = false,
    }) {
      try {
        const fileUrl = url || await this.$axios.$post('/courses/file', {
          courseId, name, assignmentId, lectureId, index, certificateId, courseZip, assignmentZip, textLesson,
        });

        const link = document.createElement('a');
        link.href = fileUrl;
        if (target) {
          link.target = target;
        }
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        if (error.response.data && !['fileNotFound', 'cannotAccessPaidResource'].includes(error.response.data.error)) {
          await this.$store.dispatch('modals/open', {
            name: 'default',
            title: error.response.data.errorMessage,
          });
        }
      }
    },
    blogPostURL(item) {
      let href = '/';

      if (item.parentCategorySlug) {
        href += `${item.parentCategorySlug}/`;
      }

      if (item.categorySlug) {
        href += `${item.categorySlug}/`;
      }

      href += `${item.slug}/`;

      return href;
    },

    async logout() {
      const logout = await this.$store.dispatch('auth/logout', { reset: false });
      if (logout) {
        cookies.remove('hideBanners');
        window.location.href = `${this.$config.siteUrl}/login/`;
      }
    },

    href(item) {
      let url = '';
      if (item.type === 'course') {
        url = `/courses/preview/${item.slug}/`;
      } else if (item.type === 'lesson') {
        url = `/courses/${item.courseSlug}/${item.slug}/`;
      } else if (item.type === 'practice') {
        url = `/quiz/${item.id}/`;
      } else if (item.type === 'project') {
        url = `/projects/${item.slug}/`;
      }

      return url;
    },
    breadcrumb(item, type) {
      const obj = [];

      if (type === 'blog') {
        obj.push({ slug: '/blog/', name: 'Blog' });

        if (item.parentCategorySlug) {
          obj.push({ slug: `/${item.parentCategorySlug}/`, name: item.parentCategory });
        }

        if (item.categorySlug) {
          obj.push({
            slug: `/${item.parentCategorySlug ? `${item.parentCategorySlug}/` : ''}${item.categorySlug}/`,
            name: item.categoryName,
          });
        }

        if (item.title) {
          obj.push({
            slug: '',
            name: item.title,
          });
        }
      } else if (type === 'blogCategory') {
        obj.push({ slug: '/blog/', name: 'Blog' });

        if (item.parentSlug) {
          obj.push({ slug: `/${item.parentSlug}/`, name: item.parentCategory });
        }

        if (item.slug) {
          obj.push({ slug: '', name: item.category });
        }
      }

      return obj;
    },
    removeTags(html) {
      if (!html) {
        return '';
      }
      return html.toString().replace(/<[^>]*>/g, '');
    },

    metaProps(data) {
      let dateCreated = '';
      let dateUpdated = '';
      if (data.date) {
        dateCreated = data.date;
        dateUpdated = data.dateUpdated;
      } else if (data.created) {
        dateCreated = this.dateIsoString(data.created);
        dateUpdated = this.dateIsoString(data.updated);
      }

      const twitter = this.$config.platform === 'ds' ? '@365datascience' : '@365finanalyst';
      const facebook = this.$config.platform === 'ds' ? 'https://www.facebook.com/365DataScience/' : 'https://www.facebook.com/365financialanalyst';

      const indexation = { name: 'robots', content: data.robots || (this.$route.query.search || this.$route.fullPath.includes('?search') || this.$route.fullPath.includes('&search') ? 'noindex, follow' : 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1') };

      const obj = [
        indexation,
        { property: 'article:publisher', content: facebook },
        { ...(dateCreated) && { property: 'article:published_time', content: dateCreated } },
        { ...(dateUpdated) && { property: 'article:modified_time', content: dateUpdated } },
        { ...(data.metaDescription) && { name: 'description', content: data.metaDescription } },
        { property: 'og:type', content: 'article' },
        { property: 'og:locale', content: 'en_US' },
        { property: 'og:site_name', content: this.$config.platformName },
        { ...(data.fullPath) && { property: 'og:url', content: data.fullPath } },
        { ...(data.ogTitle || data.metaTitle) && { property: 'og:title', content: `${data.ogTitle || data.metaTitle} – ${this.$config.platformName}` } },
        { ...(data.ogDescription || data.metaDescription) && { property: 'og:description', content: data.ogDescription || data.metaDescription } },
        { property: 'og:image', content: this.metaImagePath(data, 'facebook') },
        { property: 'og:image:width', content: data.ogImageWidth || data.metaImageWidth || 1200 },
        { property: 'og:image:height', content: data.ogImageHeight || data.metaImageHeight || 630 },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:creator', content: twitter },
        { name: 'twitter:site', content: twitter },
        { name: 'twitter:image', content: this.metaImagePath(data, 'twitter') },
        { ...(data.twitterTitle || data.ogTitle || data.metaTitle) && { name: 'twitter:title', content: `${data.twitterTitle || data.ogTitle || data.metaTitle} – ${this.$config.platformName}` } },
        { ...(data.twitterDescription || data.metaDescription) && { name: 'twitter:description', content: data.twitterDescription || data.metaDescription } },
      ];

      return obj;
    },

    metaImagePath(data, socalMedia) {
      let imagePath = socalMedia === 'facebook' ? (data.ogImage || data.metaImage) : (data.twitterImage || data.metaImage);

      if (imagePath && !imagePath.startsWith('http')) {
        let dir = '/meta/';
        if (data.isBlog) {
          dir = '/blog/';
        } else if (data.isCertificate) {
          dir = '/certificates/';
        }
        imagePath = `${this.$config.imagesUrl}${dir}${imagePath}`;
      } else if (!imagePath) {
        const platformImg = this.$config.platform === 'ds' ? '365-Data-Science-Open-Graph.png' : '365-Financial-Analyst-Open-Graph.png';
        imagePath = `${this.$config.imagesUrl}/${this.$route.name !== 'certificates-number' ? platformImg : 'certificate-open-graph.png'}`;
      }

      return imagePath;
    },

    checkLmsAccess() {
      setTimeout(() => {
        const elements = document.getElementsByClassName('lms-access');
        // eslint-disable-next-line no-restricted-syntax
        for (const key in elements) {
          // eslint-disable-next-line no-prototype-builtins
          if (elements.hasOwnProperty(key)) {
            const element = elements[key];
            if (!element.classList.contains('eventAttached')) {
              element.addEventListener('click', () => {
                element.classList.add('eventAttached');
                if (!this.$store.state.auth.user) {
                  window.location.href = '/signup';
                }
              });
            }
          }
        }
      }, 500);
    },

    loadGallery(parent) {
      if (parent.length) {
        const srcMaxSizeArr = [];

        parent[0].querySelectorAll('*:not(a):not(div.image-gallery) > img, a[href]').forEach((el) => {
          const url = el.getAttribute('href');
          if (el.tagName === 'IMG' && !el.classList.contains('no-lightbox')) {
            const wrap = document.createElement('div');
            const elParent = el.parentNode;
            wrap.classList.add('image-gallery');
            elParent.replaceChild(wrap, el);
            wrap.appendChild(el);
            if (el.style.float === 'right') {
              wrap.setAttribute('style', 'margin-left: auto; margin-right: 0;');
            } else if (el.style.float === 'left') {
              wrap.setAttribute('style', 'margin-left: 0; margin-right: auto;');
            } else if (el.style.display === 'block' && el.style.marginLeft === 'auto' && el.style.marginRight === 'auto') {
              wrap.setAttribute('style', 'margin-left: auto; margin-right: auto;');
            }
            const { src, dataset } = wrap.querySelector('img');

            let newSource = src;
            if (dataset && dataset.ext) {
              newSource = src.replace(/resources\/(.+?)\/thumb@[0-9]{2,4}_/, (m0, m1) => `resources/${m1}/`).replace(/webp$/, dataset.ext);
            }

            srcMaxSizeArr.push(newSource);
            const activeIdx = srcMaxSizeArr.length;

            wrap.addEventListener('click', async (e) => {
              e.preventDefault();

              this.$store.dispatch('modals/open', {
                name: 'gallery', images: srcMaxSizeArr, activeIdx, type: 'inline',
              });
            });
          } else if (url && (url.includes('jpg') || url.includes('png')) && el.childNodes.length === 1 && el.childNodes[0].tagName === 'IMG') {
            const { src, dataset } = el.querySelector('img');

            let newSource = src;
            if (dataset && dataset.ext) {
              newSource = src.replace(/resources\/(.+?)\/thumb@[0-9]{2,4}_/, (m0, m1) => `resources/${m1}/`).replace(/webp$/, dataset.ext);
            }

            srcMaxSizeArr.push(newSource);
            const activeIdx = srcMaxSizeArr.length;

            el.classList.add('image-gallery');
            el.addEventListener('click', async (e) => {
              e.preventDefault();
              this.$store.dispatch('modals/open', {
                name: 'gallery', images: srcMaxSizeArr, activeIdx, type: 'inline',
              });
            });
          }
        });
      }
    },
    capitalizeFirstLetters(str) {
      return str.split(' ').map((v) => v.replace(/^./, (v[0] || '').toUpperCase())).join(' ');
    },
    dateIsoString(formatDate) {
      const date = formatDate ? new Date(`${formatDate}`.replace(/-/g, '/')) : new Date();

      if (date.toString() === 'Invalid Date') {
        return '';
      }

      return date.toISOString();
    },
    webp(src) {
      return src.replace(/^(.+)\..+$/, '$1.webp');
    },
    validateEmail(email) {
      // eslint-disable-next-line no-control-regex
      const regex = /^(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return regex.test(email);
    },
    extractEmails(emails) {
      // eslint-disable-next-line no-control-regex
      const r = emails.match(/(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gm);

      return [...new Set(r)].map((e) => e.trim().toLowerCase()).filter((e) => this.validateEmail(e));
    },
  },
};
